import React from "react";

const Alert = () => {
    return <div className="alert">Answer is requierd!</div>
};

export default Alert;